import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { PrivateRoute, PublicRoute } from './Route';

import Home from '~/pages/Home';
import ForgotPassword from '~/pages/ForgotPassword';
import Avatar from '~/pages/Avatar';
import Terms from '~/pages/Terms';
// import Erro from '~/pages/Erro';

import SignIn from '~/pages/SignIn';
import SignUp from '~/pages/SignUp';

import Dashboard from '~/pages/Dashboard';
import Index from '~/pages/Index';

import PageNotFound from '~/pages/PageNotFound';
import EmailSent from '~/pages/EmailSent';
import EmailValidation from '~/pages/EmailValidation';
import NewPass from '~/pages/NewPass';

import RegistrarMusica from '~/subpages/RegistrarMusica';
import Registered from '~/subpages/Registered';
import RegistryError from '~/subpages/RegistryError';

import Resume from '~/subpages/Inicio/Resume';
import Credit from '~/subpages/Inicio/Credit';
import AddPlan from '~/subpages/Inicio/Credit/AddPlan';
import AddCredit from '~/subpages/Inicio/Credit/AddCredit';
import SuccessCard from '~/subpages/Inicio/Credit/AddCredit/SuccessCard';
import SuccessBillet from '~/subpages/Inicio/Credit/AddCredit/SuccessBillet';
import SuccessPix from '~/subpages/Inicio/Credit/AddCredit/SuccessPix';
import Score from '~/subpages/Inicio/Score';
import AdicionarPontos from '~/subpages/Inicio/Score/EarnPoints';
import Ranking from '~/subpages/Inicio/Ranking';
import RankingGeral from '~/subpages/RankingGeneral';

import Perfil from '~/subpages/Perfil';
import AlterarSenha from '~/subpages/Perfil/AlterPassword';
import MinhasMusicas from '~/subpages/MinhasMusicas';
import RecordedMusicDashboard from '~/subpages/RecordedMusicDashboard';
import MinhasCompras from '~/subpages/MinhasCompras';
import Usuarios from '~/subpages/Dashboard/Usuarios';
import Tutoriais from '~/subpages/Tutoriais';
import Video from '~/subpages/Tutoriais/Video';
import {
  General,
  Register,
  Market,
  Juridico,
  Launch,
  News,
} from '~/subpages/Perguntas';
// import Playlists from '~/subpages/Playlists';
// import CreatePlayList from '~/subpages/Playlists/CreatePlayList';
// import PlayListSelected from '~/subpages/Playlists/PlayListSelected';
import RecordedMusic from '~/pages/RecordedMusic';
import ValidacaoCertificado from '~/pages/ValidacaoCertificado';
import ValidacaoCertificadoDashboard from '~/subpages/ValidacaoCertificadoDashboard';
import ValidacaoVoucher from '~/subpages/ValidacaoVoucher';
import Configuracoes from '~/subpages/Dashboard/Configuracoes';

export default function AppRoutes() {
  return (
    <Routes>
      {/* Rotas Públicas */}

      <Route path="/" element={<PublicRoute><Home /></PublicRoute>} />

      <Route path="/cadastro" element={<PublicRoute><SignUp /></PublicRoute>} />
      <Route path="/validation/:message" element={<PublicRoute><EmailValidation /></PublicRoute>} />

      <Route path="/login/:token" element={<PublicRoute><SignIn /></PublicRoute>} />
      <Route path="/login/senha-alterada/:message" element={<PublicRoute><SignIn /></PublicRoute>} />
      <Route path="/login" element={<PublicRoute><SignIn /></PublicRoute>} />
      <Route path="/redefinir-senha" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
      <Route path="/avatar" element={<PublicRoute><Avatar /></PublicRoute>} />
      <Route path="/termos" element={<PublicRoute><Terms /></PublicRoute>} />
      <Route
        path="/email-enviado/:title/:message"
        element={<PublicRoute><EmailSent /></PublicRoute>}
      />
      <Route path="/alterar-senha/:hash" element={<PublicRoute><NewPass /></PublicRoute>} />
      <Route path="/musica-registrada/:key" element={<PublicRoute><RecordedMusic /></PublicRoute>} />

      <Route path="/validacao/registro/certificado/:hashAcordeon" element={<PublicRoute><ValidacaoCertificado /></PublicRoute>} />
      <Route path="/validacao/registro/certificado" element={<PublicRoute><ValidacaoCertificado /></PublicRoute>} />


      {/* Rotas Privadas */}

      <Route
        path="/dashboard/validacao/registro/certificado/:hashAcordeon"
        element={<PrivateRoute><ValidacaoCertificadoDashboard /></PrivateRoute>}
      />

      <Route
        path="/dashboard/validacao/voucher"
        element={<PrivateRoute><ValidacaoVoucher /></PrivateRoute>}
      />

      <Route
        path="/dashboard/inicio/resumo"
        element={<PrivateRoute><Dashboard /></PrivateRoute>}
      />
      <Route path="/dashboard/index" element={<PrivateRoute><Index /></PrivateRoute>} />
      <Route
        path="/dashboard/registrar-musica"
        element={<PrivateRoute><RegistrarMusica /></PrivateRoute>}
      />
      <Route
        path="/dashboard/registrar-musica/registro-enviado"
        element={<PrivateRoute><Registered /></PrivateRoute>}
      />
      <Route
        path="/dashboard/registrar-musica/registro-erro"
        element={<PrivateRoute><RegistryError /></PrivateRoute>}
      />
      <Route
        path="/dashboard/inicio/resumo"
        element={<PrivateRoute><Resume /></PrivateRoute>}
      />
      <Route
        path="/dashboard/inicio/creditos"
        element={<PrivateRoute><Credit /></PrivateRoute>}
      />
      <Route
        path="/dashboard/adicionar-creditos/planos"
        element={<PrivateRoute><AddPlan /></PrivateRoute>}
      />
      <Route
        path="/dashboard/adicionar-creditos/finalizar-compra"
        element={<PrivateRoute><AddCredit /></PrivateRoute>}
      />
      <Route
        path="/dashboard/adicionar-creditos/compra-efetuada-cartao"
        element={<PrivateRoute><SuccessCard /></PrivateRoute>}
      />
      <Route
        path="/dashboard/adicionar-creditos/compra-efetuada-boleto"
        element={<PrivateRoute><SuccessBillet /></PrivateRoute>}
      />
      <Route
        path="/dashboard/adicionar-creditos/compra-efetuada-pix"
        element={<PrivateRoute><SuccessPix /></PrivateRoute>}
      />
      <Route
        path="/dashboard/inicio/pontos"
        element={<PrivateRoute><Score /></PrivateRoute>}
      />
      <Route
        path="/dashboard/adicionar-pontos"
        element={<PrivateRoute><AdicionarPontos /></PrivateRoute>}
      />
      <Route
        path="/dashboard/inicio/ranking"
        element={<PrivateRoute><Ranking /></PrivateRoute>}
      />
      <Route
        path="/dashboard/ranking"
        element={<PrivateRoute><RankingGeral /></PrivateRoute>}
      />
      {/* <Route path="/dashboard/pagSuccess" element={<PrivateRoute><Inicio /></PrivateRoute>} /> */}
      <Route path="/dashboard/perfil" element={<PrivateRoute><Perfil /></PrivateRoute>} />
      <Route
        path="/dashboard/perfil/alterar-senha"
        element={<PrivateRoute><AlterarSenha /></PrivateRoute>}
      />
      <Route
        path="/dashboard/minhas-musicas"
        element={<PrivateRoute><MinhasMusicas /></PrivateRoute>}
      />
      <Route
        path="/dashboard/musica-registrada/:key"
        element={<PrivateRoute><RecordedMusicDashboard /></PrivateRoute>}
      />
      <Route
        path="/dashboard/minhas-compras"
        element={<PrivateRoute><MinhasCompras /></PrivateRoute>}
      />
      <Route
        path="/dashboard/admin/lista-usuarios"
        element={<PrivateRoute><Usuarios /></PrivateRoute>}
      />
      <Route
        path="/dashboard/admin/configuracoes"
        element={<PrivateRoute><Configuracoes /></PrivateRoute>}
      />
      <Route
        path="/dashboard/tutoriais"
        element={<PrivateRoute><Tutoriais /></PrivateRoute>}
      />
      <Route
        path="/dashboard/tutoriais/video/:key"
        element={<PrivateRoute><Video /></PrivateRoute>}
      />
      <Route
        path="/dashboard/perguntas/geral"
        element={<PrivateRoute><General /></PrivateRoute>}
      />
      <Route
        path="/dashboard/perguntas/registro-de-musica"
        element={<PrivateRoute><Register /></PrivateRoute>}
      />
      <Route
        path="/dashboard/perguntas/mercado-para-compositores"
        element={<PrivateRoute><Market /></PrivateRoute>}
      />
      <Route
        path="/dashboard/perguntas/juridico"
        element={<PrivateRoute><Juridico /></PrivateRoute>}
      />
      <Route
        path="/dashboard/perguntas/lancamento"
        element={<PrivateRoute><Launch /></PrivateRoute>}
      />
      <Route
        path="/dashboard/perguntas/novidades"
        element={<PrivateRoute><News /></PrivateRoute>}
      />

      <Route path="*" element={<PageNotFound />} />


      {/* Play Lists */}

      {/* <Route
        path="/dashboard/playlists"
        element={<PrivateRoute><Playlists /></PrivateRoute>}
      />
      <Route
        path="/dashboard/playlists/criar-playlist"
        element={<PrivateRoute><CreatePlayList /></PrivateRoute>}
      />
      <Route
        path="/dashboard/playlists/playlist-selecionada/:key"
        element={<PrivateRoute><PlayListSelected /></PrivateRoute>}
      /> */}
      {/* Tratar erro de rota */}
      {/* <Route path="*" element={<Erro />} /> */}
    </Routes>
  );
}
